function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { CoreVideoInternal } from '../core-video-internal';
import { AdInsertionStrategy, AdsFailoverReason } from '../core/player/playout-data';
import { sdkLogger } from '../logger';
import { AdPolicyManager } from '../propositions/ad-policy/ad-policy-manager';
import { AdvertsInsertionStageManager } from './adverts-manager-stages/adverts-insertion-stage-manager';
import { AdvertsInitialisationStageManager } from './adverts-manager-stages/adverts-initialisation-stage-manager';
import { AdBreakSource, AdBreakUpdateMergeStrategy, SsaiStitcherType } from './adverts/common';
import { CompanionAdvertDispatcher } from './adverts/companion-adverts/companion-advert-dispatcher';
import { MidBreakSeekingEventsAddon } from './adverts/mid-break-seeking-events-addon';
import { PauseAdvertDispatcher } from './adverts/pause-adverts/pause-advert-dispatcher';
import { AdvertBufferingBreadcrumbAddon } from './debug/advert-buffering-breadcrumb-addon';
import { AdvertsVacStageManager } from './adverts-manager-stages/adverts-vac-stage-manager';
import { AdInsertionType } from './ad-insertion-type';
import { JsonUtils } from '../utils/json-utils';
export var AdvertsManager = /*#__PURE__*/ function() {
    "use strict";
    function AdvertsManager(adInsertionClientConfig, session, addonsFactories, umvToken, getToken) {
        var _this = this;
        _class_call_check(this, AdvertsManager);
        _define_property(this, "adInsertionClientConfig", void 0);
        _define_property(this, "session", void 0);
        _define_property(this, "addonsFactories", void 0);
        _define_property(this, "umvToken", void 0);
        _define_property(this, "getToken", void 0);
        _define_property(this, "adInsertionAddon", void 0);
        _define_property(this, "ssaiAddon", void 0);
        _define_property(this, "csaiAddon", void 0);
        _define_property(this, "isNativeCsai", void 0);
        _define_property(this, "adInsertionConfig", void 0);
        _define_property(this, "pauseAdvertDispatcher", void 0);
        _define_property(this, "companionAdvertDispatcher", void 0);
        _define_property(this, "sessionSideAdTransitionBoltOn", void 0);
        _define_property(this, "sessionSideThumbnailInfoUtils", void 0);
        _define_property(this, "adPolicyManager", void 0);
        _define_property(this, "adBreakTimeAdapter", void 0);
        _define_property(this, "adBreaksProvider", void 0);
        _define_property(this, "adEventsManager", void 0);
        _define_property(this, "timedActionsScheduler", void 0);
        _define_property(this, "advertBufferingBreadcrumbAddon", void 0);
        _define_property(this, "midBreakSeekingEventsAddon", void 0);
        _define_property(this, "sessionItem", void 0);
        _define_property(this, "proposition", void 0);
        _define_property(this, "isVacEnabled", void 0);
        _define_property(this, "vacAddon", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "advertsInitialisationStageManager", void 0);
        _define_property(this, "advertsVacStageManager", void 0);
        _define_property(this, "advertsInsertionStageManager", void 0);
        _define_property(this, "vodAdverts", void 0);
        _define_property(this, "playoutData", void 0);
        _define_property(this, "handleCatchupSeek", void 0);
        this.adInsertionClientConfig = adInsertionClientConfig;
        this.session = session;
        this.addonsFactories = addonsFactories;
        this.umvToken = umvToken;
        this.getToken = getToken;
        this.adInsertionAddon = null;
        this.csaiAddon = null;
        this.isNativeCsai = false;
        this.sessionSideThumbnailInfoUtils = null;
        this.advertBufferingBreadcrumbAddon = null;
        this.isVacEnabled = false;
        this.vacAddon = null;
        this.logger = sdkLogger.withContext('AdvertsManager');
        this.advertsVacStageManager = null;
        this.advertsInsertionStageManager = null;
        this.handleCatchupSeek = function(catchupSeek) {
            _this.session.notifyCatchupSeek(catchupSeek);
        };
        this.proposition = CoreVideoInternal.config.staticConfig.proposition;
        this.advertsInitialisationStageManager = new AdvertsInitialisationStageManager(this.adInsertionClientConfig);
    }
    _create_class(AdvertsManager, [
        {
            key: "initialise",
            value: function initialise(sessionItem, initialPlayoutData) {
                var _this_addonsFactories_vac, _this_addonsFactories;
                this.playoutData = this.advertsInitialisationStageManager.initialise(sessionItem, initialPlayoutData);
                if (this.advertsInitialisationStageManager.isDisabled()) {
                    return this.playoutData;
                }
                this.sessionItem = sessionItem;
                this.vacAddon = (_this_addonsFactories_vac = (_this_addonsFactories = this.addonsFactories).vac) === null || _this_addonsFactories_vac === void 0 ? void 0 : _this_addonsFactories_vac.call(_this_addonsFactories, this.adInsertionClientConfig, sessionItem, initialPlayoutData, this.umvToken, this.getToken);
                this.isVacEnabled = Boolean(this.vacAddon);
                this.createAdInsertionAddon(initialPlayoutData);
                if (!this.adInsertionAddon && !this.isNativeCsai) {
                    return initialPlayoutData;
                }
                this.createAdInsertionComponents(sessionItem);
                return this.playoutData;
            }
        },
        {
            key: "fetchVamData",
            value: function fetchVamData(sessionItem, initialPlayoutData, context) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        _this.advertsVacStageManager = new AdvertsVacStageManager(_this.adInsertionClientConfig, _this.session, _this.adInsertionAddon, _this.adInsertionConfig, _this.isVacEnabled, _this.vacAddon, _this.isNativeCsai, context === null || context === void 0 ? void 0 : context.isPrefetch);
                        return [
                            2,
                            _this.advertsVacStageManager.fetchVacData(sessionItem, initialPlayoutData)
                        ];
                    });
                })();
            }
        },
        {
            key: "bootstrapAds",
            value: function bootstrapAds(populatedPlayoutData) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_ssaiAddon, e, _this_ssaiAddon1, message, code;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (_this_ssaiAddon = _this.ssaiAddon) === null || _this_ssaiAddon === void 0 ? void 0 : _this_ssaiAddon.bootstrap(populatedPlayoutData)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                message = 'Error bootstrapping ads, ads may not be shown';
                                _this.logger.warn(message, JsonUtils.stringify(e));
                                code = 'SDK.ADVERTSMGR.SETUP_ADS.SSAI.BOOTSTRAP_ADS';
                                _this.session.notifyWarning(code, message);
                                populatedPlayoutData.adsFailoverReason = (_this_ssaiAddon1 = _this.ssaiAddon) === null || _this_ssaiAddon1 === void 0 ? void 0 : _this_ssaiAddon1.getAdsFailoverReason();
                                _this.destroy();
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchAdvertisementData",
            value: function fetchAdvertisementData(populatedPlayoutData, initialPlayoutData) {
                var _this = this;
                return _async_to_generator(function() {
                    var supportsNativeCsai, modifiedPlayoutData, message, code, _this_adEventsManager;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.advertsInsertionStageManager = new AdvertsInsertionStageManager(_this.session, _this.pauseAdvertDispatcher, _this.adPolicyManager, _this.adBreaksProvider, _this.adInsertionAddon, _this.ssaiAddon);
                                supportsNativeCsai = CoreVideoInternal.playerCapabilities.supportsNativeCsai;
                                return [
                                    4,
                                    _this.advertsInsertionStageManager.fetchAdvertisementData(populatedPlayoutData, initialPlayoutData, {
                                        supportsNativeCsai: supportsNativeCsai
                                    })
                                ];
                            case 1:
                                modifiedPlayoutData = _state.sent();
                                if (!supportsNativeCsai) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.getVodAdverts()
                                ];
                            case 2:
                                modifiedPlayoutData.csaiAdBreaks = _state.sent().map(function(group) {
                                    return group.adBreak;
                                });
                                if (modifiedPlayoutData.csaiAdBreaks && !_this.adEventsManager) {
                                    message = 'Error processing vod ad breaks. No Ad Events Manager present.';
                                    _this.logger.warn(message);
                                    code = 'SDK.ADVERTSMGR.SETUP_ADS.SLE_PREROLL';
                                    _this.session.notifyWarning(code, message);
                                } else {
                                    ;
                                    (_this_adEventsManager = _this.adEventsManager) === null || _this_adEventsManager === void 0 ? void 0 : _this_adEventsManager.handleAdBreakDataReceived({
                                        adBreaks: modifiedPlayoutData.csaiAdBreaks,
                                        source: AdBreakSource.OutOfBand,
                                        mergeStrategy: AdBreakUpdateMergeStrategy.Merge
                                    });
                                }
                                _state.label = 3;
                            case 3:
                                _this.adInsertionConfig = _object_spread({}, _this.adInsertionConfig, modifiedPlayoutData.adInsertionConfig);
                                if (modifiedPlayoutData.adsFailoverReason) {
                                    _this.destroy();
                                }
                                return [
                                    2,
                                    modifiedPlayoutData
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createAdInsertionComponents",
            value: function createAdInsertionComponents(sessionItem) {
                var _this_adPolicyManager;
                this.advertBufferingBreadcrumbAddon = new AdvertBufferingBreadcrumbAddon(this.session);
                this.midBreakSeekingEventsAddon = new MidBreakSeekingEventsAddon(this.session);
                if (this.adInsertionAddon) {
                    this.adInsertionConfig = this.adInsertionAddon.playoutOptions;
                    this.adInsertionAddon.setVacAddon(this.vacAddon);
                    switch(this.adInsertionConfig.adInsertionStrategy){
                        case AdInsertionStrategy.SSAI:
                            this.ssaiAddon = this.adInsertionAddon;
                            this.adInsertionConfig.ssaiStitcherType = this.ssaiAddon.getSsaiStitcherType();
                            this.sessionSideAdTransitionBoltOn = this.ssaiAddon.getSessionSideAdTransitionBoltOn();
                            this.sessionSideThumbnailInfoUtils = this.ssaiAddon.getSessionSideThumbnailInfoUtils();
                            // Case Yospace, create AdPolicy in the addon-manager
                            // This is needed because Yospace notifies the session with ad events and by creating the ad policy manager
                            // at this level, we'll be able to have access to those events and pass them down to the Yospace ad events manager
                            this.adPolicyManager = this.ssaiAddon.getAdPolicyManager();
                            this.adBreaksProvider = this.ssaiAddon.getAdBreaksProvider();
                            this.adBreakTimeAdapter = this.ssaiAddon.getAdBreakTimeAdapter();
                            this.adEventsManager = this.ssaiAddon.getAdEventsManager();
                            this.timedActionsScheduler = this.ssaiAddon.getTimedActionsScheduler();
                            break;
                        case AdInsertionStrategy.CSAI:
                            this.csaiAddon = this.adInsertionAddon;
                            this.adInsertionConfig.ssaiStitcherType = SsaiStitcherType.None;
                            this.adPolicyManager = new AdPolicyManager({
                                isSeekManagementRequired: true,
                                isWatchedAdsManagementRequired: false,
                                allowSeekingDuringAdBreaks: false,
                                allowAdSkipCatchup: false,
                                proposition: this.proposition,
                                sessionItem: sessionItem
                            });
                            break;
                        default:
                            break;
                    }
                } else if (this.isNativeCsai) {
                    var nativeCsaiAdInsertionConfig = {
                        adInsertionStrategy: AdInsertionStrategy.CSAI,
                        isPlayerAdEventsRequired: true,
                        isPlayerAdBreakDataRequired: false,
                        isTimelineAdManagementRequired: false,
                        adProvider: AdInsertionType.NativeCsai,
                        ssaiStitcherType: SsaiStitcherType.None
                    };
                    this.adPolicyManager = new AdPolicyManager({
                        isSeekManagementRequired: false,
                        isWatchedAdsManagementRequired: !CoreVideoInternal.playerCapabilities.hasNativeWatchedAdsManagement,
                        allowSeekingDuringAdBreaks: false,
                        allowAdSkipCatchup: false,
                        proposition: this.proposition,
                        sessionItem: sessionItem
                    });
                    this.adInsertionConfig = nativeCsaiAdInsertionConfig;
                }
                (_this_adPolicyManager = this.adPolicyManager) === null || _this_adPolicyManager === void 0 ? void 0 : _this_adPolicyManager.onCatchupSeek(this.handleCatchupSeek);
            }
        },
        {
            key: "createAdInsertionAddon",
            value: function createAdInsertionAddon(initialPlayoutData) {
                var _this_sessionItem_vac, _this_sessionItem, _this_sessionItem_vac1, _this_sessionItem1;
                this.pauseAdvertDispatcher = new PauseAdvertDispatcher(this.session);
                var disableCompanionAdsWhenCaptionEnabled = ((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_vac = _this_sessionItem.vac) === null || _this_sessionItem_vac === void 0 ? void 0 : _this_sessionItem_vac.disableFrameAdsWhenCaptionEnabled) || ((_this_sessionItem1 = this.sessionItem) === null || _this_sessionItem1 === void 0 ? void 0 : (_this_sessionItem_vac1 = _this_sessionItem1.vac) === null || _this_sessionItem_vac1 === void 0 ? void 0 : _this_sessionItem_vac1.disableCompanionAdsWhenCaptionEnabled);
                this.companionAdvertDispatcher = new CompanionAdvertDispatcher(this.session, disableCompanionAdsWhenCaptionEnabled);
                var sessionData = {
                    sessionAdEvents: this.session,
                    sessionItem: this.sessionItem,
                    playoutData: initialPlayoutData,
                    hasNativeAdEvents: CoreVideoInternal.playerCapabilities.hasNativeAdEvents,
                    pauseAdvertDispatcher: this.pauseAdvertDispatcher,
                    companionAdvertDispatcher: this.companionAdvertDispatcher,
                    adInsertionConfig: this.adInsertionClientConfig,
                    playerType: CoreVideoInternal.getCurrentPlayerTypeForPlayoutData(initialPlayoutData)
                };
                try {
                    var _this_addonsFactories_adInsertion, _this_addonsFactories;
                    this.adInsertionAddon = (_this_addonsFactories_adInsertion = (_this_addonsFactories = this.addonsFactories).adInsertion) === null || _this_addonsFactories_adInsertion === void 0 ? void 0 : _this_addonsFactories_adInsertion.call(_this_addonsFactories, sessionData);
                    if (!this.adInsertionAddon && this.isVacEnabled) {
                        this.isNativeCsai = true;
                    }
                } catch (e) {
                    this.logger.error('Unable to instantiate Ad Insertion Addon', e);
                    this.adInsertionAddon = null;
                    return;
                }
            }
        },
        {
            key: "finishCurrentAd",
            value: function finishCurrentAd(sessionProxy) {
                var ad = this.getCurrentAd();
                var adBreak = this.getCurrentAdBreak();
                if (ad) {
                    sessionProxy.notifyAdFinished(ad);
                }
                if (adBreak) {
                    sessionProxy.notifyAdBreakFinished(adBreak);
                }
            }
        },
        {
            key: "getVodStartPositionAfterCurrentAdvert",
            value: function getVodStartPositionAfterCurrentAdvert() {
                // Return a position 0.5s after the current ad break start
                var currentAdBreak = this.getCurrentAdBreak();
                if (!currentAdBreak) {
                    return null;
                }
                var adBreakStartPosition = typeof currentAdBreak.position === 'number' ? currentAdBreak.position : 0;
                return adBreakStartPosition + 0.5;
            }
        },
        {
            key: "getCurrentAdBreak",
            value: function getCurrentAdBreak() {
                var _this_advertsInsertionStageManager;
                return (_this_advertsInsertionStageManager = this.advertsInsertionStageManager) === null || _this_advertsInsertionStageManager === void 0 ? void 0 : _this_advertsInsertionStageManager.getCurrentAdBreak();
            }
        },
        {
            key: "getCurrentAd",
            value: function getCurrentAd() {
                var _this_advertsInsertionStageManager;
                return (_this_advertsInsertionStageManager = this.advertsInsertionStageManager) === null || _this_advertsInsertionStageManager === void 0 ? void 0 : _this_advertsInsertionStageManager.getCurrentAd();
            }
        },
        {
            key: "getAdInsertionConfig",
            value: function getAdInsertionConfig() {
                return this.adInsertionConfig;
            }
        },
        {
            key: "getAdvertBoltOns",
            value: function getAdvertBoltOns() {
                return {
                    adBreakTimeAdapter: this.adBreakTimeAdapter,
                    transition: this.sessionSideAdTransitionBoltOn,
                    policyManager: this.adPolicyManager,
                    breaksProvider: this.adBreaksProvider,
                    eventsManager: this.adEventsManager,
                    timedActionsScheduler: this.timedActionsScheduler,
                    pauseAdvertDispatcher: this.pauseAdvertDispatcher
                };
            }
        },
        {
            key: "getPauseAdvertDispatcher",
            value: function getPauseAdvertDispatcher() {
                return this.pauseAdvertDispatcher;
            }
        },
        {
            key: "getThumbnailInfoUtils",
            value: function getThumbnailInfoUtils() {
                return this.sessionSideThumbnailInfoUtils;
            }
        },
        {
            key: "getVodAdverts",
            value: function getVodAdverts() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_advertsInsertionStageManager;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.vodAdverts) {
                                    return [
                                        2,
                                        _this.vodAdverts
                                    ];
                                }
                                if (!_this.csaiAddon) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.csaiAddon.getAdvertsForSession()
                                ];
                            case 1:
                                _this.vodAdverts = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                if (!((_this_advertsInsertionStageManager = _this.advertsInsertionStageManager) === null || _this_advertsInsertionStageManager === void 0 ? void 0 : _this_advertsInsertionStageManager.getTimelineAdsAddon())) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.advertsInsertionStageManager.getTimelineAdsAddon().getAdvertsForSession()
                                ];
                            case 3:
                                _this.vodAdverts = _state.sent();
                                _state.label = 4;
                            case 4:
                                if (!_this.vodAdverts) {
                                    _this.vodAdverts = [];
                                }
                                return [
                                    2,
                                    _this.vodAdverts
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handlePositionChange",
            value: function handlePositionChange(timeIncludingAds) {
                if (this.ssaiAddon) {
                    this.ssaiAddon.handlePositionChange(timeIncludingAds);
                }
            }
        },
        {
            key: "handleSeekStarted",
            value: function handleSeekStarted(timeIncludingAds) {
                if (this.adBreakTimeAdapter) {
                    var _this_midBreakSeekingEventsAddon;
                    var adPosition = this.adBreakTimeAdapter.timeIncludingAdsToAdPosition(timeIncludingAds);
                    (_this_midBreakSeekingEventsAddon = this.midBreakSeekingEventsAddon) === null || _this_midBreakSeekingEventsAddon === void 0 ? void 0 : _this_midBreakSeekingEventsAddon.handleSeekStarted(adPosition);
                }
            }
        },
        {
            key: "timeIncludingAdsToContentTime",
            value: function timeIncludingAdsToContentTime(timeIncludingAds) {
                if (this.adBreakTimeAdapter) {
                    return this.adBreakTimeAdapter.timeIncludingAdsToContentTime(timeIncludingAds);
                } else {
                    return timeIncludingAds;
                }
            }
        },
        {
            key: "manageStartPosition",
            value: function manageStartPosition(timeIncludingAds) {
                if (this.adPolicyManager) {
                    return this.adPolicyManager.manageStartPosition(timeIncludingAds);
                }
                return timeIncludingAds;
            }
        },
        {
            key: "contentTimeToTimeIncludingAds",
            value: function contentTimeToTimeIncludingAds(contentTime) {
                if (this.adBreakTimeAdapter) {
                    return this.adBreakTimeAdapter.contentTimeToTimeIncludingAds(contentTime);
                } else {
                    return contentTime;
                }
            }
        },
        {
            key: "adaptAdBreaksPositionsToContentTime",
            value: function adaptAdBreaksPositionsToContentTime(adBreaks) {
                if (this.adBreakTimeAdapter) {
                    return adBreaks.map(this.adBreakTimeAdapter.adBreakPositionIncludingAdsToContentPosition, this);
                } else {
                    return adBreaks;
                }
            }
        },
        {
            key: "adBreakPositionIncludingAdsToContentPosition",
            value: function adBreakPositionIncludingAdsToContentPosition(adBreak) {
                if (this.adBreakTimeAdapter) {
                    return this.adBreakTimeAdapter.adBreakPositionIncludingAdsToContentPosition(adBreak);
                } else {
                    return adBreak;
                }
            }
        },
        {
            key: "notifyManifestLoadError",
            value: function notifyManifestLoadError(error) {
                this.destroy();
            }
        },
        {
            key: "modifyPlayoutDataForCdnSwitch",
            value: function modifyPlayoutDataForCdnSwitch(playoutData) {
                return this.ssaiAddon !== undefined ? _object_spread_props(_object_spread({}, playoutData), {
                    adsFailoverReason: AdsFailoverReason.Generic
                }) : playoutData;
            }
        },
        {
            key: "getAdvertisementInitialisationStatus",
            value: function getAdvertisementInitialisationStatus() {
                return this.advertsInitialisationStageManager.getInitialisationStatus();
            }
        },
        {
            key: "isInitialPositionAdjustmentRequired",
            value: function isInitialPositionAdjustmentRequired() {
                var _this_ssaiAddon;
                return Boolean((_this_ssaiAddon = this.ssaiAddon) === null || _this_ssaiAddon === void 0 ? void 0 : _this_ssaiAddon.isInitialPositionAdjustmentRequired);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this_vacAddon, _this_adInsertionAddon, _this_advertBufferingBreadcrumbAddon, _this_adPolicyManager, _this_advertsInsertionStageManager;
                this.logger.verbose("Destroying Adverts Manager");
                (_this_vacAddon = this.vacAddon) === null || _this_vacAddon === void 0 ? void 0 : _this_vacAddon.destroy();
                (_this_adInsertionAddon = this.adInsertionAddon) === null || _this_adInsertionAddon === void 0 ? void 0 : _this_adInsertionAddon.destroy();
                (_this_advertBufferingBreadcrumbAddon = this.advertBufferingBreadcrumbAddon) === null || _this_advertBufferingBreadcrumbAddon === void 0 ? void 0 : _this_advertBufferingBreadcrumbAddon.destroy();
                (_this_adPolicyManager = this.adPolicyManager) === null || _this_adPolicyManager === void 0 ? void 0 : _this_adPolicyManager.disable();
                (_this_advertsInsertionStageManager = this.advertsInsertionStageManager) === null || _this_advertsInsertionStageManager === void 0 ? void 0 : _this_advertsInsertionStageManager.destroy();
                this.advertsVacStageManager = null;
                this.advertsInsertionStageManager = null;
                this.vacAddon = null;
                this.adInsertionAddon = null;
                // @ts-ignore
                this.adInsertionConfig = null;
                this.ssaiAddon = undefined;
                this.csaiAddon = null;
                this.advertBufferingBreadcrumbAddon = null;
                this.sessionSideAdTransitionBoltOn = undefined;
                this.pauseAdvertDispatcher = undefined;
                this.adPolicyManager = undefined;
                this.adBreaksProvider = undefined;
                this.adBreakTimeAdapter = undefined;
                this.adEventsManager = undefined;
                this.timedActionsScheduler = undefined;
            }
        },
        {
            key: "advertisingData",
            get: function get() {
                var _this_adInsertionAddon;
                return (_this_adInsertionAddon = this.adInsertionAddon) === null || _this_adInsertionAddon === void 0 ? void 0 : _this_adInsertionAddon.advertisingData;
            }
        }
    ]);
    return AdvertsManager;
}();

//# sourceMappingURL=adverts-manager.js.map